/**
 *
 * @param {Object} string - DOM element
 * @param {Strign} replace - word wich have to be replaced with span
 */

export const modifyAndReplaceWords = (string, replace) => {
  let input = string.innerHTML
  let toReplace = replace
  let newWord = `<span>${toReplace}</span>`
  let regEx = new RegExp(toReplace, 'g')
  let output = input.replace(regEx, newWord)
  string.innerHTML = output
}

/**
 * Throttle function.
 *
 */
export const throttle = (func, ms) => {
  var isThrottled = false,
    savedArgs,
    savedThis

  function wrapper() {
    if (isThrottled) {
      savedArgs = arguments
      savedThis = this
      return
    }

    func.apply(this, arguments)

    isThrottled = true

    setTimeout(function() {
      isThrottled = false
      if (savedArgs) {
        wrapper.apply(savedThis, savedArgs)
        savedArgs = savedThis = null
      }
    }, ms)
  }

  return wrapper
}

export class Resp {
  /**
   * Get window's current width.
   *
   * @get
   * @static
   * @return {Number}
   */
  static get currWidth() {
    return window.innerWidth
  }

  /**
   * Get window's current height.
   *
   * @get
   * @static
   * @return {Number}
   */
  static get currHeight() {
    return window.innerHeight
  }

  /**
   * Detect touch events.
   *
   * @get
   * @static
   * @return {Boolean}
   */
  static get isTouch() {
    return 'ontouchstart' in document.documentElement
  }

  /**
   * Detect XL desktop device.
   *
   * @get
   * @static
   * @return {Boolean}
   */
  static get isXL() {
    return process.browser
      ? window.matchMedia(`(min-width: 1600px)`).matches
      : false
  }

  /**
   * Detect All desktop device.
   *
   * @get
   * @static
   * @return {Boolean}
   */
  static get allDesk() {
    return process.browser
      ? window.matchMedia(`(min-width: 1261px)`).matches
      : false
  }

  /**
   * Detect desktop device.
   *
   * @get
   * @static
   * @return {Boolean}
   */
  static get isDesktopL() {
    return process.browser
      ? window.matchMedia(`(min-width: 1600px)`).matches
      : false
  }

  /**
   * Detect desktop device.
   *
   * @get
   * @static
   * @return {Boolean}
   */
  static get isDesktop() {
    return process.browser
      ? window.matchMedia(`(min-width: 1280px)`).matches
      : false
  }

  /**
   * Detect tablet device.
   *
   * @get
   * @static
   * @return {Boolean}
   */
  static get isTablet() {
    return process.browser
      ? window.matchMedia(`(min-width: 768px) and (max-width: 1279px)`).matches
      : false
  }

  /**
   * Detect tablet device. (landscape)
   *
   * @get
   * @static
   * @return {Boolean}
   */
  static get isTabletL() {
    return process.browser
      ? window.matchMedia(`(min-width: 992px) and (max-width: 1229px)`).matches
      : false
  }

  /**
   * Detect tablet device. (portrait)
   *
   * @get
   * @static
   * @return {Boolean}
   */
  static get isTabletP() {
    return process.browser
      ? window.matchMedia(`(min-width: 768px) and (max-width: 991px)`).matches
      : false
  }

  /**
   * Detect mobile device.
   *
   * @get
   * @static
   * @return {Boolean}
   */
  static get isMobile() {
    return process.browser
      ? window.matchMedia(`(max-width: 767px)`).matches
      : false
  }

  /**
   * Detect safari web-browser.
   *
   * @get
   * @static
   * @return {Boolean}
   */
  static get isSafari() {
    const ua = navigator.userAgent.toLowerCase()
    return !!window.safari || (ua.includes('safari') && !ua.includes('chrome'))
  }

  /**
   * Detect iOS device.
   *
   * @get
   * @static
   * @return {Boolean}
   */
  static get isIos() {
    return /iphone|ipod|ipad/i.test(navigator.userAgent)
  }

  /**
   * Detect iOS device on Chrome.
   *
   * @get
   * @static
   * @return {Boolean}
   */
  static get isIosChrome() {
    return /CriOS/i.test(navigator.userAgent) && Resp.isIos
  }

  /**
   * Detect firefox web-browser.
   *
   * @get
   * @static
   * @return {Boolean}
   */
  static get isFirefox() {
    return typeof window.InstallTrigger !== 'undefined'
  }

  /**
   * Detect internet explorer web-browser.
   *
   * @get
   * @static
   * @return {Boolean}
   */
  static get isIE() {
    return (
      navigator.userAgent.indexOf('MSIE') !== -1 ||
      navigator.appVersion.indexOf('Trident/') > 0
    )
  }
}

/**
 * Check if element is in viewport.
 *
 * @param {HTMLElement} element
 * @param {Boolean} [fullyInView = false] - element should be fully in viewport?
 * @param {Number} [offsetTop = 0]
 * @returns {Boolean}
 */
export const isScrolledIntoView = (
  element,
  offsetTop = 0,
  fullyInView = false
) => {
  const { height: elHeight, top: elTop } = element.getBoundingClientRect()
  const pageTop = window.pageYOffset
  const pageBottom = pageTop + window.innerHeight
  const elementTop = elTop + offsetTop
  const elementBottom = elementTop + elHeight

  if (fullyInView === true) {
    return pageTop < elementTop && pageBottom > elementBottom
  }

  return elementTop <= pageBottom && elementBottom >= pageTop
}

/**
 * Swipe.
 *
 * @param {HTMLElement} zone
 * @param {Object} directions
 *
 */

export const swipe_js = (zone, directions) => {
  let pageWidth = process.browser
      ? window.innerWidth || document.body.clientWidth
      : -1,
    threshold = Math.max(1, Math.floor(0.01 * pageWidth)),
    touchstartX = 0,
    touchstartY = 0,
    touchendX = 0,
    touchendY = 0

  const limit = Math.tan(((45 * 1.5) / 180) * Math.PI),
    gestureZone = zone

  gestureZone.addEventListener(
    'touchstart',
    function(event) {
      touchstartX = event.changedTouches[0].screenX
      touchstartY = event.changedTouches[0].screenY
    },
    false
  )

  gestureZone.addEventListener('touchend', touched, false)

  function touched(event) {
    touchendX = event.changedTouches[0].screenX
    touchendY = event.changedTouches[0].screenY
    handleGesture(event)
  }

  function handleGesture(e) {
    let x = touchendX - touchstartX
    let y = touchendY - touchstartY
    let xy = Math.abs(x / y)
    let yx = Math.abs(y / x)

    if (Math.abs(x) > threshold || Math.abs(y) > threshold) {
      if (yx <= limit) {
        if (x < 0) {
          if (directions.left !== undefined) directions.left()
        } else {
          if (directions.right !== undefined) directions.right()
        }
      }
      if (xy <= limit) {
        if (y < 0) {
          if (directions.top !== undefined) directions.top()
        } else {
          if (directions.bottom !== undefined) directions.bottom()
        }
      }
    } else {
      if (directions.tap !== undefined) directions.tap()
    }
  }
}

/**
 * Get scroll bar width
 * @get
 * @static
 * @returns {Number}
 *
 */
export const getScrollBarWidth = () => {
  let inner = document.createElement('p'),
    outer = document.createElement('div')

  inner.style.cssText = 'width:100%;height:200px'
  outer.style.cssText =
    'position:absolute;top:0px;left:0px;visibility:hidden;width:200px;height:150px;overflow:hidden'
  outer.appendChild(inner)
  document.body.appendChild(outer)
  let w1 = inner.offsetWidth,
    w2 = inner.offsetWidth
  outer.style.overflow = 'scroll'
  if (w1 === w2) w2 = outer.clientWidth
  document.body.removeChild(outer)

  return w1 - w2
}

export function getFormElementNames(form) {
  if (!form) return

  return [...form.elements].map(el => el.name).filter(name => name)
}

export function getFirstErrorInput(form) {
  if (!form) return

  return [...form.elements].find(el =>
    el.classList.contains('input-wrap__field_input_error')
  )
}

/**
 *
 * @param text - optional, text for measure instead of innerText of element
 * @param elem - element - context for text style. by default get innerText for measure
 * @return Number
 */
export function measureTextWidth(elem, text) {
  if (!elem) return 0

  let elemStyle = getComputedStyle(elem)

  let contextStyle = {
    'font-size': elemStyle.fontSize,
    'font-family': elemStyle.fontFamily,
    'letter-spacing': elemStyle.letterSpacing,
    'font-weight': elemStyle.fontWeight,
    'white-space': elemStyle.whiteSpace,
    display: 'inline-block',
    position: 'absolute',
    opacity: 0
  }

  // create temp element
  let span = document.createElement('span')

  // set context style for temp elem
  for (let key in contextStyle) {
    span.style[key] = contextStyle[key]
  }

  span.innerText = text ? text : elem.innerText
  document.body.appendChild(span)

  let textWidth = span.clientWidth

  // remove created element
  document.body.removeChild(span)

  return textWidth
}



// WEBPACK FOOTER //
// ./plugins/_helpers.js